import { company } from '@cascade/core/constants';
import { useProjects } from '@cascade/react/projects';
import { Image } from '@cascade/ui-library';
import clsx from 'clsx';
import classes from './Logo.module.scss';
import logoUrl from './logo.svg';

export const Logo = () => {
  const { settings } = useProjects();

  const projectLogoUrl = settings?.project_theme?.logo_url;
  const hasProjectLogo = Boolean(projectLogoUrl);

  return (
    <Image
      src={projectLogoUrl || logoUrl}
      fit='contain'
      title={company.name}
      className={clsx(classes.logo, { [classes.project]: hasProjectLogo })}
    />
  );
};
